import { ConceptStatusValidity, ConceptStatusValuePrimitive } from "@fusion-advantage/backcompat"
import L1ValueLabel from "../l1/L1ValueLabel"
import { FusionColor } from "../../../theme/FusionStyle"
import { validityIndicatorProps } from "../../uiv2/Indicator/StatusIndicatorProps"

interface L3ValueLabelProps {
	size?: 'max',
	colorByValidity?: boolean
	value: ConceptStatusValuePrimitive|null
	validity: ConceptStatusValidity|null
}

const L3ValueLabel = ({size, colorByValidity, value, validity}: L3ValueLabelProps) => {
	let color: FusionColor|undefined
	if(colorByValidity && validity) {
		const props = validityIndicatorProps(validity)
		color = props.color
	}
	return (
		<L1ValueLabel size={size} color={color}>
			{value}
		</L1ValueLabel>
	)
}

export default L3ValueLabel
